import { useApiClient } from '@@common';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ContextClient, ContextModel } from '../../../api/api';

export function useApiContexts(): UseQueryResult<ContextModel[], Error> {
    const client = useApiClient(ContextClient);
    
    const contexts = useQuery({
        queryKey: ['contexts'],
        queryFn: async () => {
            console.log('useApiContexts - Making API call to load all contexts');
            try {
                const result = await client.getAllContexts();
                console.log('useApiContexts - API response:', result);
                return result;
            } catch (error) {
                console.error('useApiContexts - API error:', error);
                throw error;
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    });
    
    console.log('useApiContexts - Query state:', {
        data: contexts.data,
        isLoading: contexts.isLoading,
        isError: contexts.isError,
        error: contexts.error
    });
    
    return contexts;
}
